import React, { forwardRef, useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { registerUserLogin, verifyOtp } from '../../store/authActions';
import { getSignupSourceMeta } from '../../utils/signupSource';
import { trackLogin, trackSignUp, trackAuthSuccess, trackFormStart } from '../../utils/analytics';
import { validateMobile, isValidEmail } from '../../utils/utils';

const LoginPopup = forwardRef(({ url, email }, ref) => {
  const [formData, setFormData] = useState({ email: email || "" });
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [otp, setOtp] = useState({
    1: "",
    2: "",
    3: "",
    4: ""
  });
  const [errorOtp, setErrorOtp] = useState("");
  const [userId, setUserId] = useState("");
  const inputsRef = useRef([]);
  const [isLoadingLogin, setIsLoadingLogin] = useState(false);
  const [isDeletedAccount, setIsDeletedAccount] = useState(false);

  useEffect(() => {
    if (email !== undefined && email !== null) {
      setFormData((prev) => ({
        ...prev,
        email: email
      }));
      setIsDeletedAccount(false);
      setError("");
      setErrorOtp("");
    }
  }, [email]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    // Auto-detect: if only digits entered, treat as mobile (max 10), else allow as email
    const isMobileInput = /^\d*$/.test(value);
    const cleanValue = isMobileInput ? value.slice(0, 10) : value;
    setFormData((prev) => ({
      ...prev,
      [name]: cleanValue,
    }));
    if (isDeletedAccount) setIsDeletedAccount(false);
    if (error) setError("");
  };


  const handleChangeOTP = (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    if (value.length > 1) {
      return;
    }

    setOtp((prev) => ({
      ...prev,
      [index]: value
    }));


    if (value && index < 4) {
      inputsRef.current[index + 1].focus();
    }

    if (errorOtp) {
      setErrorOtp("");
    }
  };

  const handleSubmitOTPButton = async (e) => {
    e.preventDefault();
    const fullOtp = `${otp[1]}${otp[2]}${otp[3]}${otp[4]}`;

    if (!fullOtp) {
      setErrorOtp('OTP is required');
      return;
    }

    if (fullOtp.length !== 4) {
      setErrorOtp('OTP is invalid');
      return;
    }

    if (!userId) {
      setErrorOtp('Please resend OTP and try again');
      return;
    }

    setIsLoading(true);
    setErrorOtp("");

    try {
      const sourceMeta = typeof getSignupSourceMeta === "function" ? getSignupSourceMeta() : {};
      const apiBase = (process.env.REACT_APP_BASE_URL_API || "http://localhost:8080").replace(/\/+$/, "");

      const res = await fetch(`${apiBase}/api/user/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ otp: fullOtp, userId, ...sourceMeta }),
        credentials: "include"
      });

      const data = await res.json();
      setIsLoading(false);

      if (data.status) {
        // Login popup is strictly for existing user logins
        trackLogin('Mobile OTP', data.user_id || userId);
        trackAuthSuccess('existing');

        dispatch(verifyOtp(data));
        dispatch(registerUserLogin(data));

        if (url === 'reload') {
          window.location.reload();
        } else if (url) {
          document.location.href = url;
        } else if (data.page && data.page !== 'dashboard') {
          document.location.href = `/${data.page}`;
        } else {
          document.location.href = '/dashboard';
        }
      } else {
        setErrorOtp(data.message || 'Invalid OTP');
      }
    } catch (err) {
      console.error("verifyOtp error:", err);
      setErrorOtp("Unable to verify OTP. Please try again.");
      setIsLoading(false);
    }
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsDeletedAccount(false);

    const inputValue = String(formData.email || "").trim();
    const isMobileInput = /^\d+$/.test(inputValue);
    if (isMobileInput) {
      if (!validateMobile(inputValue)) {
        setError("Please enter a valid 10-digit mobile number.");
        return;
      }
    } else {
      if (!isValidEmail(inputValue)) {
        setError("Please enter a valid email or 10-digit mobile number.");
        return;
      }
    }
    trackFormStart("Login Popup", 1);

    try {
      const apiBase = (process.env.REACT_APP_BASE_URL_API || "http://localhost:8080").replace(/\/+$/, "");
      const res = await fetch(`${apiBase}/api/user/registration-login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
        credentials: "include"
      });

      const data = await res.json();
      if (data.status) {
        setUserId(data.userID || "");
        setIsLoadingLogin(true);
        setIsDeletedAccount(false);
        setError("");
        setErrorOtp("");
      } else if (data.is_deleted) {
        setIsDeletedAccount(true);
        setUserId(data.userID || "");
        setError("");
      } else {
        setIsDeletedAccount(false);
        setError(data.message || "Failed to send OTP");
      }
    } catch (err) {
      console.error("Login popup error:", err);
      setError("Unable to connect to server. Please try again.");
    }
  };

  useEffect(() => {
    if (email) {
      setFormData({ email: email })
    }

  }, [email])




  return (
    <>
      <div
        className="modal fade loginpop"
        id="loginModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        ref={ref}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content position-relative">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
            <div className="modal-body">
              <div className="poplogo">
                <img
                  src="/assets/img/logo-light.png"
                  alt="Vivashri"
                  title="Vivashri"
                />
              </div>
              <h5>{isDeletedAccount ? "Account Deactivated" : "Welcome Back! Please Login"}</h5>
              <div className="normal-login d-none">
                <div className="loginformrow">
                  <label htmlFor="">
                    Mobile No./ Email ID <span className="red">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Mobile No./ Email ID"
                    className="form-control"
                  />
                </div>
                <div className="loginformrow">
                  <label htmlFor="">
                    Password <span className="red">*</span>
                  </label>
                  <input
                    type="password"
                    placeholder="Mobile No./ Email ID"
                    className="form-control"
                  />
                  <div className="text-end">
                    <a href="/#" className="forgotpass">
                      Forgot Password?
                    </a>
                  </div>
                </div>
                <div className="loginformrow pt-2">
                  <a href="/#" className="button login-btn d-block text-center">
                    Login
                  </a>
                </div>
                <div className="or">
                  <span className="">or</span>
                </div>
                <div className="loginformrow">
                  <a href="/#" className="button login-btn d-block text-center">
                    Login with OTP
                  </a>
                </div>
              </div>
              <div className="otp-login ">

                {isDeletedAccount && !isLoadingLogin ? (
                  <div
                    className="account-restore-box p-3 my-2 text-center"
                    style={{
                      background: 'linear-gradient(135deg, #fff9f2 0%, #fff3e6 100%)',
                      borderRadius: '14px',
                      border: '1px solid #ffd8a8',
                      boxShadow: '0 4px 16px rgba(232, 89, 12, 0.1)'
                    }}
                  >
                    <div
                      className="mb-2"
                      style={{
                        width: '54px',
                        height: '54px',
                        margin: '0 auto',
                        borderRadius: '50%',
                        backgroundColor: '#ffe8cc',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#e8590c',
                        fontSize: '22px'
                      }}
                    >
                      <i className="fa-solid fa-headset"></i>
                    </div>
                    <h6 style={{ fontWeight: '700', color: '#c92a2a', fontSize: '16px', marginBottom: '6px' }}>
                      Account Deactivated / Deleted
                    </h6>
                    <p style={{ color: '#495057', fontSize: '13px', lineHeight: '1.5', margin: '0 0 16px 0' }}>
                      An account registered with <strong>{formData.email}</strong> has been deleted. To restore or reactivate your account, please contact our support team or an authorized agent member.
                    </p>

                    <a
                      href="/contact-us"
                      className="button login-btn d-flex align-items-center justify-content-center w-100"
                      style={{
                        background: 'linear-gradient(135deg, #e8590c 0%, #d9480f 100%)',
                        border: 'none',
                        color: '#fff',
                        fontWeight: '600',
                        padding: '11px 16px',
                        borderRadius: '8px',
                        boxShadow: '0 4px 12px rgba(217, 72, 15, 0.3)',
                        fontSize: '14px',
                        textDecoration: 'none'
                      }}
                    >
                      <i className="fa-solid fa-headset me-2"></i> Contact Support / Agent
                    </a>

                    <div className="mt-3">
                      <button
                        type="button"
                        className="btn btn-link text-muted p-0"
                        style={{ fontSize: '12px', textDecoration: 'none', color: '#6c757d', border: 'none', background: 'none' }}
                        onClick={() => {
                          setIsDeletedAccount(false);
                          setFormData({ email: '' });
                          setError('');
                        }}
                      >
                        <i className="fa-solid fa-arrow-left me-1"></i> Use another Mobile Number
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="loginformrow" >
                    <form onSubmit={handleSubmit}>
                      <label htmlFor="">
                        Mobile Number / Email <span className="red">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Mobile Number or Email Address"
                        className="form-control"
                        onChange={handleChange}
                        name='email'
                        value={formData.email || ''}
                        disabled={isLoadingLogin}
                        maxLength={100}
                        autoComplete="username"
                        required
                      />

                      <div className="d-flex align-items-center justify-content-between">
                        <span className="otpnot">We will send you an OTP on your Mobile / Email</span>
                        <div className="text-end">
                          {isLoadingLogin &&
                            <Link to="#" className="sendotp" onClick={() => {
                              setIsLoadingLogin(false);
                              setIsDeletedAccount(false);
                              setOtp({ 1: "", 2: "", 3: "", 4: "" });
                              setErrorOtp("");
                            }}>
                              Back
                            </Link>
                          }
                        </div>
                      </div>

                      {error && <p className='otpnot red'>{error}</p>}
                      {!isLoadingLogin &&
                        <div className="loginformrow pt-2">
                          <button type='submit' className="button login-btn d-block text-center" style={{ width: '100%' }}>
                            Send OTP
                          </button>
                        </div>
                      }

                    </form>
                  </div>
                )}

                <div>
                  {isLoadingLogin &&
                    <form onSubmit={handleSubmitOTPButton}>
                      <div className="loginformrow mt-0">
                        <label className="mt-0" htmlFor="">
                          Enter OTP <span className="red">*</span>
                        </label>
                        <div className="otp-boxes">
                          <input type="text" maxLength={1} className="otp-input"
                            key={1}
                            min={0}
                            ref={(el) => (inputsRef.current[1] = el)}
                            onChange={(e) => handleChangeOTP(e, 1)}
                            value={otp[1]}
                            autoFocus
                          />
                          <input type="text" maxLength={1} className="otp-input"
                            key={2}
                            min={0}
                            ref={(el) => (inputsRef.current[2] = el)}
                            onChange={(e) => handleChangeOTP(e, 2)}
                            value={otp[2]}
                          />
                          <input type="number" maxLength={1} className="otp-input"
                            key={3}
                            min={0}
                            ref={(el) => (inputsRef.current[3] = el)}
                            onChange={(e) => handleChangeOTP(e, 3)}
                            value={otp[3]}
                          />
                          <input type="number" maxLength={1} className="otp-input"
                            key={4}
                            min={0}
                            ref={(el) => (inputsRef.current[4] = el)}
                            onChange={(e) => handleChangeOTP(e, 4)}
                            value={otp[4]}
                          />

                        </div>
                        {errorOtp && <p className='otpnot red'>{errorOtp}</p>}
                      </div>
                      <div className="loginformrow pt-2">
                        <button type='submit' className="button login-btn d-block text-center" style={{ width: '100%' }}>
                          Submit OTP
                        </button>
                      </div>
                    </form>
                  }
                </div>



                { /* <div className="or">
            <span className="">or</span>
          </div>
          <div className="loginformrow">
            <button href="/#" className="button login-btn d-block text-center" style={{width:'100%'}}>
              Login with Password
            </button>
          </div>
          */ }
              </div>
              <div className="loginformrow">
                { /* <div className="d-flex align-items-center justify-content-between">
            <a href="/#" className="button loginwdfb me-2">
              <i className="fa-brands fa-facebook-f" /> Facebook
            </a>
            <a href="/#" className="button loginwdgoogle">
              <i className="fa-brands fa-google" /> Google
            </a>
          </div> */ }
                <p className="newto text-center">
                  New to Vivashri? <a href="/registration">Sign Up Free</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
})

export default LoginPopup
